import * as React from 'react';
import { FluidPanel } from 'ui';
import styles from './loss-potential-consequence-evaluation-footer.scss';

export interface LossPotentialConsequenceEvaluationFooterProps {
  componentId: any;
  childValues: any;
}

export const LossPotentialConsequenceEvaluationFooter = (props: LossPotentialConsequenceEvaluationFooterProps) => {

  const { childValues } = props;

  const hasChildValues = !!childValues?.filter(cv=>cv.value).length;
  
  return (hasChildValues ? 
      
    <div className={styles.lossPotentialConsequenceEvaluationFooter}>
      <FluidPanel {...props} className=''/></div>
    : null);
};
